export default __webpack_public_path__ + "static/media/alien.819e8c2e.gif";